export interface ProductType {
  productTypeId: number;
  productTypeDesc: string;
  productTypeCode?: string;
}
